import { render, staticRenderFns } from "./shipping-audit-queue.vue?vue&type=template&id=893703b8&"
import script from "./js/shipping-audit-queue.js?vue&type=script&lang=js&"
export * from "./js/shipping-audit-queue.js?vue&type=script&lang=js&"
import style0 from "./shipping-audit-queue.vue?vue&type=style&index=0&id=893703b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports